import script from "./MysticAltar.vue?vue&type=script&setup=true&lang=js"
export * from "./MysticAltar.vue?vue&type=script&setup=true&lang=js"

import "./MysticAltar.vue?vue&type=style&index=0&id=322e7d40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-322e7d40"]])

export default __exports__